(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["storaze-showroom-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('storaze-showroom')) {
  customElements.define('storaze-showroom', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return; this.initialized=true;
      this.copy=JSON.parse(this.querySelector('[data-sz-copy]').textContent);
      this.querySelectorAll('[data-sz-compare-label]').forEach(el=>el.hidden=false);
      this.dialog=this.querySelector('dialog');
      this.addEventListener('change',e=>{if(!e.target.matches('[data-sz-compare]'))return;let picked=this.picked();if(picked.length>3){e.target.checked=false;this.notice(this.copy.max);}else{this.notice('');}this.update();});
      this.addEventListener('click',e=>{
        const b=e.target.closest('button');if(!b)return;
        if(b.hasAttribute('data-sz-clear')){this.querySelectorAll('[data-sz-compare]').forEach(x=>x.checked=false);this.update();this.notice('');}
        if(b.hasAttribute('data-sz-close'))this.dialog.close();
        if(b.hasAttribute('data-sz-open')){if(this.picked().length<2){this.notice(this.copy.min);return;}this.build();this.dialog.showModal();}
      });
    }
    picked(){return [...this.querySelectorAll('[data-sz-compare]:checked')].map(x=>x.closest('[data-sz-card]'));}
    notice(t){this.querySelector('[data-sz-notice]').textContent=t;}
    update(){const n=this.picked().length;this.querySelector('.sz-compare-tray').hidden=n===0;this.querySelector('[data-sz-selected]').textContent=n+' / 3';}
    build(){const body=this.querySelector('[data-sz-table]');body.replaceChildren();const products=this.picked();
      ['title','brand','category','price','status','options'].forEach(key=>{const tr=document.createElement('tr');const th=document.createElement('th');th.scope='row';th.textContent=this.copy[key];tr.append(th);products.forEach(p=>{const td=document.createElement('td');if(key==='title'){const a=document.createElement('a');a.href=p.dataset.url;a.textContent=p.dataset.title;td.append(a);}else{td.textContent=p.querySelector('[data-sz-'+key+']')?.textContent.trim()||'—';}tr.append(td);});body.append(tr);});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
